import { ErrorFallback } from '../../../components/error/ErrorFallback';
export function NotFoundPage() {
  return <ErrorFallback error={new Error('page_not_found')} resetError={() => {}} />;
}
